import { useTranslation } from "react-i18next";
import type { ICompanyChangeRequest } from "@/types/company-change-request";
import Alert from "@/components/Alert";
import { Button, useBoolean } from "@/ui-kit";
import type { ILender } from "@/types/companies-lenders";
import type { IContractingCompany } from "@/types/companies-contractors";
import { ChangeCompanyFormUser } from "@/components/ChangeCompany/ChangeCompanyFormUser";

type IProps = {
  request: ICompanyChangeRequest | undefined;
  company: ILender | IContractingCompany | undefined;
  companyType: "lender" | "contractor";
};

export const ChangeCompanyRequestAlert = ({
  request,
  company,
  companyType,
}: IProps) => {
  const { t } = useTranslation();

  const {
    value: showRequestModal,
    setTrue: openRequestModal,
    setFalse: dismissRequestModal,
  } = useBoolean(false);

  if (!request || !company) return null;

  return (
    <>
      <Alert
        variant="info"
        title={t("label.changeCompany.youHaveSubmittedACompanyChangeRequest")}
        controls={
          <Button
            size="sm"
            variant="outlined"
            content={t("label.changeCompany.reviewRequest")}
            onClick={openRequestModal}
          />
        }
      />
      {showRequestModal && (
        <ChangeCompanyFormUser
          companyType={companyType}
          currentCompany={company}
          request={request}
          onDismiss={dismissRequestModal}
        />
      )}
    </>
  );
};
